export type AiChatVoiceUiAction = {
  enableVoiceChat: boolean;
};

function normalizeVoiceText(raw: string): string {
  return raw.trim().toLowerCase().replace(/\s+/g, " ");
}

/** Local UI commands — open AI drawer, switch to Chat, optionally enable voice chat. */
export function parseAiChatVoiceCommand(raw: string): AiChatVoiceUiAction | null {
  const text = normalizeVoiceText(raw);
  if (!text) return null;

  if (
    text === "enable chat" ||
    /^enable\s+(ai\s+)?(voice\s+)?chat$/.test(text)
  ) {
    return { enableVoiceChat: true };
  }

  if (text === "start ai chat" || /\bstart\s+ai\s+chat\b/.test(text)) {
    return { enableVoiceChat: true };
  }

  if (
    text === "open ai chat" ||
    text === "open the ai chat" ||
    /\bopen\s+(the\s+)?ai\s+chat\b/.test(text)
  ) {
    return { enableVoiceChat: false };
  }

  if (text === "ai chat") {
    return { enableVoiceChat: false };
  }

  return null;
}

export function isAiChatUiVoiceCommand(raw: string): boolean {
  return parseAiChatVoiceCommand(raw) !== null;
}

export const AI_CHAT_UI_COMMAND_EVENT = "rcm-ai-chat-ui-command";

export function dispatchAiChatUiVoiceCommand(action: AiChatVoiceUiAction): void {
  window.dispatchEvent(new CustomEvent("rcm-ai-drawer-open"));
  window.dispatchEvent(
    new CustomEvent<AiChatVoiceUiAction>(AI_CHAT_UI_COMMAND_EVENT, {
      detail: action,
    }),
  );
}

/** When true, chat input comes from the global voice assistant (drawer mic is off). */
export const VOICE_CHAT_MODE_EVENT = "rcm-voice-chat-mode";

export function dispatchVoiceChatMode(active: boolean): void {
  window.dispatchEvent(
    new CustomEvent<{ active: boolean }>(VOICE_CHAT_MODE_EVENT, {
      detail: { active },
    }),
  );
}

export const VOICE_CHAT_INPUT_EVENT = "rcm-voice-chat-input";

export function dispatchVoiceChatInput(text: string): void {
  window.dispatchEvent(
    new CustomEvent<{ text: string }>(VOICE_CHAT_INPUT_EVENT, {
      detail: { text },
    }),
  );
}

export type VoiceChatListeningDetail = {
  listening: boolean;
  previewText: string;
};

export const VOICE_CHAT_LISTENING_EVENT = "rcm-voice-chat-listening";

export function dispatchVoiceChatListening(detail: VoiceChatListeningDetail): void {
  window.dispatchEvent(
    new CustomEvent<VoiceChatListeningDetail>(VOICE_CHAT_LISTENING_EVENT, {
      detail,
    }),
  );
}
